import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../components/Component";

const PaymentsAside = ({ updateSm, sm }: any) => {
  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Payments</span>
            <span className="sub-text">
              Manage payment creation, approvals, processing, and tracking
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/create-payment`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-circle" />
              <span>Create Payment</span>
            </Link>
          </li>
          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/invoice-payables`}
              onClick={() => updateSm(false)}
            >
              <Icon name="file-text" />
              <span>Invoice Payables</span>
            </Link>
          </li> */}
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/pending-payment-approvals`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-round" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/run-payments`}
              onClick={() => updateSm(false)}
            >
              <Icon name="play" />
              <span>Run Payments</span>
            </Link>
          </li> */}
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/view-payments`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list" />
              <span>View Payments</span>
            </Link>
          </li>
          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/payment-analytics`}
              onClick={() => updateSm(false)}
            >
              <Icon name="growth" />
              <span>Analytics</span>
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default PaymentsAside;